<section *ngIf="component() as component" class="news">
  <div class="news__header">
    <div class="news__title">{{ component.title }}</div>
    @if (component.has_button) {
    <a class="news__button news__button--desktop" [href]="component.external_url">
      {{ component.button_text }}
    </a>
    }
  </div>

  <tisa-carousel
    #carousel
    class="news__list"
    (scrolledToEnd)="onButtonRightStatusChanges($event)"
    (scrolledToBeginning)="onButtonLeftStatusChanges($event)"
  >
    @for ( article of articles(); track article.id) {
    <!-- TODO: set proper article href, when article component is ready -->
    <a
      class="news__tile"
      [routerLink]="['/', locale(), 'article', article.slug]"
      tisaCarouselItem
    >
      <div class="overflow-hidden">
        <img class="news__article-image" [src]="article.image.variants?.thumb?.url" />
      </div>
      <div class="news__article-description">
        <div class="news__article-info">
          <div class="news__article-category">
            {{ article.publication_category.name }}
          </div>
          <div class="news__article-date first-letter:uppercase">
            {{ article.published_at | relativeTimeFormat }}
          </div>
        </div>
        <div class="news__article-title" [title]="article.title">{{ article.title }}</div>
      </div>
    </a>
    }
  </tisa-carousel>

  <div class="news__arrows-container">
    <button
      class="news__arrow news__arrow--left"
      (click)="carousel.scrollLeft()"
      [disabled]="buttonLeftDisabled()"
    >
      <app-icon name="arrow-left"></app-icon>
    </button>
    <button
      class="news__arrow news__arrow--right"
      (click)="carousel.scrollRight()"
      [disabled]="buttonRightDisabled()"
    >
      <app-icon name="arrow-right"></app-icon>
    </button>
  </div>

  @if (component.has_button) {
  <div class="news__button-container--mobile">
    <a class="news__button news__button--mobile" [href]="component.external_url">
      {{ component.button_text }}
    </a>
  </div>
  }
</section>
